import { createContext } from 'react'
import { PageContextValue } from '../../../core/type'
import { Appraisal, AppraisalEntry } from '../type'

export const AppraisalPageContext = createContext<PageContextValue<Appraisal, AppraisalEntry>>({})
